<!--
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2020-12-21 13:14:31
 * @LastEditors: Wang Bin <email: binnuo1109@163.com> <tel: 13937670602>
 * @LastEditTime: 2021-08-11 18:57:23
 * @Description: 弹窗插件
 * @FilePath: /hsylc2021/src/components/Modal/index.vue
-->
<template>
  <div class="_component-modal">
    <div class="overlay" :class="overlayBgClass" v-if="overlay" @click="handleClickOverlay"></div>
    <div class="overlay-trans" v-else @click="handleClickOverlay"></div>
    <div class="modal-content">
      <slot></slot>
    </div>
  </div>
</template>
<script>
/**
 * 弹窗组件
 * @module Modal
 */
export default {
  name: 'Modal',
  /**
   * @prop {Boolean} overlay 是否有非透明遮罩 默认true
   * @prop {Boolean} clickOverlayClose 是否点击遮罩触发close事件 默认true
   * @prop {String} overlayColor 遮罩颜色 default = rgba(0, 0, 0, 0.6)
   */
  props: {
    overlay: {
      type: Boolean,
      default: true
    },
    clickOverlayClose: {
      type: Boolean,
      default: true
    },
    overlayWhite: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    overlayBgClass() {
      return {
        'overlay-white': this.overlayWhite
      };
    }
  },
  // mounted: function() {
  //   var appRender = document.getElementById('app');
  //   appRender.style.overflow = 'hidden';
  // },
  // destroyed: function() {
  //   var appRender = document.getElementById('app');
  //   appRender.style.overflow = '';
  // },
  methods: {
    /**
     * @event close 关闭事件
     */
    /**
     * @description 点击遮罩事件
     * @function handleClickOverlay
     */
    handleClickOverlay: function() {
      if (this.clickOverlayClose) {
        this.$emit('close');
      }
    }
  }
};
</script>
<style lang="less" src="./index.less" scoped></style>
